/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { detectPlatform } from "./detectPlatform";
export { registerTizenKeys } from "./tizen";
